import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthForm, AuthLayout } from '@features/Auth';
import { rememberReturnTo, safeReturnPath } from '@shared/lib/returnTo';

interface AuthPageProps {
  mode: 'signin' | 'signup';
}

export default function AuthPage({ mode }: AuthPageProps) {
  const [params] = useSearchParams();
  const next = params.get('next');
  // Ссылка с лендинга ведёт дальше после входа или регистрации и знакомства: «Продолжить в приложении» из демо миссии
  // дня — `?next=/stories` (2026-10-25). Адрес проверяет safeReturnPath: только пути этого приложения.
  useEffect(() => {
    if (next) rememberReturnTo(next);
  }, [next]);

  // Пришёл за игрой (демо, ролик) — подзаголовок про игру, а не про слова (прогон тестировщика 28.10).
  const fromGame = !!safeReturnPath(next)?.startsWith('/stories');
  // Из демо игры — регистрация без имени (владелец 2026-10-30).
  const light = params.get('via') === 'demo';

  return (
    <AuthLayout>
      <AuthForm mode={mode} fromGame={fromGame} light={light} />
    </AuthLayout>
  );
}
